import { inject, Injectable } from "@angular/core";

import type { BaseFilterDefinition, FilterValue } from "@filter/filter.types";
import type { JobsBillingCard, TranslateObject } from "@app/views-interfaces";
import { JobPriority, JobsAndBillingPriorityService } from "@shared/jobs-and-billing-priority";
import { SimpleFilterMulti } from "./types/simple-filter-multi";

@Injectable()
export class JobPriorityFilterService extends SimpleFilterMulti<JobsBillingCard> {
    private readonly jobsAndBillingPriorityService = inject(JobsAndBillingPriorityService);

    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "Priority",
            label: "JobsAndBilling.Priorities.Priority",
        };
    }

    protected getValue(item: JobsBillingCard): JobPriority | FilterValue | undefined {
        return item.job?.priority;
    }

    protected getLabel(statusId: string): string | undefined | null | TranslateObject {
        return Array.from(this.jobsAndBillingPriorityService.jobPriorityOptions.values())?.find((item) => item.value === statusId)?.label;
    }

    protected getAllValues(): readonly string[] {
        return (
            Array.from(this.jobsAndBillingPriorityService.jobPriorityOptions.values())?.flatMap((status) => (status.value ? [status.value] : [])) ??
            []
        );
    }
}
